<template>
  <vs-card v-if="showAssetCard">
    <vs-heading :title="props.asset.name" class="justify-space-between align-center" type="subhead"
      >{{ asset.name }}
      <vs-button
        v-if="props.canEditInventory"
        label="Edit"
        type="secondary"
        small
        class="float-end"
        @click="$emit('edit-inventory')"
      >
      </vs-button>
    </vs-heading>
    <template v-for="(condition, index) in props.asset.conditions">
      <v-row v-if="condition.quantity || props.showEmptyQuantity" :key="index" align="center">
        <v-col class="shrink">
          <vs-text type="caption">{{ condition.name }}</vs-text>
        </v-col>
        <v-col class="align-self-middle px-2">
          <div class="dotted-line" />
        </v-col>
        <v-col class="shrink">
          <vs-text type="caption">{{ condition.quantity || 0 }}</vs-text>
        </v-col>
      </v-row>
    </template>

    <div class="total-divider" />
    <v-row class="font-weight-bold">
      <v-col>
        <vs-text>Total</vs-text>
      </v-col>
      <v-col class="shrink">
        <vs-text>{{ assetTotal }}</vs-text>
      </v-col>
    </v-row>
  </vs-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { round } from 'lodash'
import { Asset } from '@/models/asset'

const props = withDefaults(
  defineProps<{
    asset: Asset
    showEmptyInventory?: boolean
    showEmptyQuantity?: boolean
    canEditInventory?: boolean
  }>(),
  {
    showEmptyInventory: false,
    showEmptyQuantity: false,
    canEditInventory: false,
  },
)

const assetTotal = computed<number>(() => {
  if (props.asset && props.asset.conditions) {
    const sum = props.asset.conditions.reduce((a, b) => (a || 0) + (b.quantity || 0), 0)
    return round(sum, 4)
  } else {
    return 0
  }
})

const isAssetEmpty = computed<boolean>(
  () => !props.asset || !props.asset.conditions || props.asset.isEmpty(),
)

const showAssetCard = computed<boolean>(() => !isAssetEmpty.value || props.showEmptyInventory)
</script>

<style scoped>
.dotted-line {
  border-top: 1px dashed #e4e4e4;
}

.total-divider {
  border-top: 2px solid #e4e4e4;
}
</style>
